import { render, staticRenderFns } from "./ChangePurchaseTax.vue?vue&type=template&id=2fdcb3f1&scoped=true&"
import script from "./ChangePurchaseTax.vue?vue&type=script&lang=js&"
export * from "./ChangePurchaseTax.vue?vue&type=script&lang=js&"
import style0 from "./ChangePurchaseTax.vue?vue&type=style&index=0&id=2fdcb3f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdcb3f1",
  null
  
)

component.options.__file = "ChangePurchaseTax.vue"
export default component.exports